const getIntEnvVariable = (name: string, defaultValue: number) => {
  const env = Number.parseInt(process.env[name]!, 10);
  return Number.isNaN(env) ? defaultValue : env;
};

const SERVICE_TYPE_ID = getIntEnvVariable('REACT_APP_ATOMYX_MANAGE_ID', 2);

export default SERVICE_TYPE_ID;
